export enum TransactionsLocators {
	dateFormField = 'dateFormField',
	dateToField = 'dateToField',
	currentTypeField = 'currentTypeField',
	transactionTypeField = 'transactionTypeField',
	applyFilterButton = 'applyFilterButton',
	clearFilterButton = 'clearFilterButton',
}
